import validate from 'validate.js';

// return only the first error message
validate.formatters.firstError = function(errors) {
    var errObj = {};
    if (errors.length > 0) {
        for (let i=0; i<errors.length; i++) {
            let field = errors[i].attribute;
            let msg = errors[i].options.message;
            errObj[field] = msg;
        }
    }
    return errObj;
};

// Stripe validation
validate.validators.stripeCardNumber = function(value, options) {
    let isValid = !!Stripe ? Stripe.card.validateCardNumber(value) : true;
    if (!isValid) {
        return options.message || "Please enter a valid card number";
    }
    return;
}
validate.validators.stripeCVC = function(value, options) {
    let isValid = !!Stripe ? Stripe.card.validateCVC(value) : true;
    if (!isValid) {
        return options.message || "Please enter a valid CVV";
    }
    return;
}

// personal details form
export const validatePersonalDetails = (values) => {
    var schema = {
        firstName: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            }
        },
        lastName: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            }
        },
        email: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            },
            email: {message: "Please enter a valid email address"}
        },
        mobile: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            },
            format: {
                pattern: /^04\d{8}$/,
                message: "Mobile number should start with 04 and have 10 digits"
            }
        },
        postcode: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            },
            format: {
                pattern: /^\d{4}$/,
                message: "Please enter a valid postcode"
            }
        },
        birthDate: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            }
        },
        hasSpecialDiet: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            }
        },
        terms: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            },
            format: {
                pattern: /(true)/,
                message: "You must agree to the terms and conditions"
            }
        }
    };
    if (values.requiresLicense && values.requiresLicense === 'true') {
        schema.licenseNumber = {
            presence: {
                message: "This field is required",
                allowEmpty: false
            }
        };
        schema.licenseState = {
            presence: {
                message: "This field is required",
                allowEmpty: false
            }
        }
    }
    if (values.hasSpecialDiet && values.hasSpecialDiet === 'true') {
        schema.specialDietNote = {
            presence: {
                message: "Please provide details of your dietary requirements",
                allowEmpty: false
            }
        }
    }
    if (values.isPerformance) {
        schema.prereq = {
            presence: {
                message: "You must confirm that you have completed the Audi Dynamic driving experience",
                allowEmpty: false
            },
            format: {
                pattern: /(true)/,
                message: "You must confirm that you have completed the Audi Dynamic driving experience"
            }
        }
    }
    var errors = validate(values, schema, {format: "firstError", fullMessages: false});
    return errors;
}

// payment form
export const validatePayment = (values) => {
    var schema = {
        name: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            }
        },
        number: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            },
            stripeCardNumber: {
                message: "Please enter a valid card number"
            }
        },
        exp_month: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            }
        },
        exp_year: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            }
        },
        cvc: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            },
            stripeCVC: {
                message: "Please enter a valid CVV"
            }
        }
    };
    var errors = validate(values, schema, {format: "firstError", fullMessages: false});
    return errors;
}

// gift card edit form
export const validateGiftCard = (values) => {
    if (values.giftCardType === "Recipient") {
        var schema = {
            recipientName: {
                presence: {
                    message: "Please enter the recipient's name",
                    allowEmpty: false
                }
            },
            recipientEmail: {
                presence: {
                    message: "Please enter the recipient's email",
                    allowEmpty: false
                },
                email: {message: "Please enter a valid email address"}
            }
        };
        var errors = validate(values, schema, {format: "firstError", fullMessages: false});
        return errors;
    }
    return;
}

// subscribe form
export const validateSubscribe = (values) => {
    var schema = {
        firstName: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            },
        },
        lastName: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            },
        },
        emailAddress: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            },
            email: {message: "Please enter a valid email address"}
        },
        postCode: {
            presence: {
                message: "This field is required",
                allowEmpty: false
            },
            format: {
                pattern: /^\d{4}$/,
                message: "Please enter a valid postcode"
            }
        },
        optIn: {
            inclusion: {
                within: [true],
                message: "This field is required"
            }
        }
    };
    var errors = validate(values, schema, {format: "firstError", fullMessages: false});
    return errors;
}
